import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import DrawingLogo from 'containers/Drawings/DrawingLogo';
import { toggleFeedVisibility } from 'containers/Feed/actions';
import PostActions from 'components/FeedList/Post/PostActions';
import ProfileIcon from 'components/ProfileIcon';
import TimeSince from 'components/TimeSince';
import { fromIso9075DateString } from 'utils/dates';
import { isEmbedded } from 'utils/mode';
import { userShape, wallPostShape } from 'utils/shapes';
import WindCreekWImage from 'resources/WindCreekWGray.svg';
import './DrawingStartSoon.css';

class DrawingStartSoon extends PureComponent {
  render() {
    const { post, user, showLegacyFeed, onDeletePost, toggleFeedVisibility } =
      this.props;
    const message = JSON.parse(post.message);
    const { name: drawingName, drawingId, description, prizes } = message;
    const className = showLegacyFeed
      ? 'legacy-feed-drawing-start-soon'
      : 'feed-drawing-start-soon';

    return (
      <div className={className}>
        <div className="feed-message-specifics">
          <ProfileIcon src={WindCreekWImage} size={30} />
          <div className="feed-message-author-container">
            <strong>A Drawing begins in 5 minutes!</strong>
            <div className="post-time">
              <TimeSince
                date={fromIso9075DateString(post.created)}
                prefix="posted"
              />
            </div>
          </div>
        </div>

        <div>
          <div className="drawing-start-soon-container">
            {prizes && <DrawingLogo className="x-small" prizes={prizes} />}

            <div className="drawing-start-soon-message">
              <div className="drawing-start-soon-message-header">
                {drawingName}
              </div>
              <div className="drawing-start-soon-message-description">
                {description}
              </div>

              {!isEmbedded() && (
                <div className="drawing-start-soon-buttons">
                  <WStoreLinkButton
                    onClick={() => {
                      toggleFeedVisibility(false);
                    }}
                  />
                  <DrawingLinkButton drawingId={drawingId} />
                </div>
              )}
            </div>
          </div>
        </div>
        <PostActions
          post={post}
          user={user}
          onDeletePost={onDeletePost}
          trashIconSize={'base'}
          showLegacyFeed={showLegacyFeed}
        />
      </div>
    );
  }
}

DrawingStartSoon.propTypes = {
  user: userShape,
  post: wallPostShape,
  showLegacyFeed: PropTypes.bool,
  onDeletePost: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  toggleFeedVisibility: show => dispatch(toggleFeedVisibility(show))
});

const withConnect = connect(null, mapDispatchToProps);

export default withConnect(DrawingStartSoon);

function DrawingLinkButton(props) {
  const to = props.drawingId ? '/drawings/' + props.drawingId : '/drawings';
  return (
    <Link
      to={to}
      className="alert-confirm btn button-color-green drawing-start-soon-button"
    >
      View Now
    </Link>
  );
}

const WSTORE_LINK_TO = {
  pathname: '/wstore',
  state: { categoryValue: 'D - Ticket' }
};

function WStoreLinkButton({ onClick }) {
  return (
    <Link
      to={WSTORE_LINK_TO}
      onClick={onClick}
      className="alert-confirm btn button-color-blue drawing-start-soon-button"
    >
      Get Entries
    </Link>
  );
}
